// extracted by mini-css-extract-plugin
export default {"dropdown":"TextBlockInput_dropdown__6+HWq","input":"TextBlockInput_input__ZJVV+","inputBlocked":"TextBlockInput_inputBlocked__2v1Qd","blinker":"TextBlockInput_blinker__GhH11"};